import { AbstractGlobalProvider } from './provider.js';
/**
 * Global {@link PurchasesProvider}.
 *
 * Allows registering multiple services to automatically detect
 * available ones and fall-back to others.
 */
class Purchases extends AbstractGlobalProvider {
    name = 'uber-purchases-provider';
    purchaseItem(itemId, count) {
        if (!this.hasProviders())
            return Promise.reject(new Error('No providers available.'));
        /* Only purchase from highest priority service */
        return this.providers[this.providers.length - 1].purchaseItem(itemId, count ?? 1);
    }
    getItemURL(itemId) {
        if (!this.hasProviders())
            return Promise.reject(new Error('No providers available.'));
        return this.providers[this.providers.length - 1].getItemURL(itemId);
    }
    isItemPurchased(itemId) {
        if (!this.hasProviders())
            return false;
        /* Only purchase from highest priority service */
        for (const p of this.providers)
            if (p.isItemPurchased(itemId))
                return true;
        return false;
    }
}
export const purchases = new Purchases();
